import * as React from 'react';
import { classes, style } from 'typestyle';
import { windowBoxShadow } from '../window/Window';
import List from '../list/List';
const Menu = ({ className, children }) => {
    return (React.createElement(List, { bordered: true, noLastItemBorder: true, className: classes('ta-menu', menuStyle, className) }, children));
};
export default Menu;
const menuStyle = style({
    padding: '4px',
    borderRadius: '12px',
    boxShadow: windowBoxShadow,
    overflow: 'hidden',
});
//# sourceMappingURL=Menu.js.map